import { handleAlert } from "../../../views/components/ui/Alerts/Index"

export const responseCodeAlert = (responseCode, message, error, label = 'Error', callBackOnOkClick = () => null, displayMessageCustom = null) => {
    let displayMessage = ''
    if (error && error?.length !== 0) {
        const arrayError = Object.values(error)
        arrayError.map(item => {
            displayMessage = displayMessage + item + '<br>'
        })
    } else {
        displayMessage = message
    }
    if (responseCode === 200 && responseCode < 400) {
        handleAlert('Success', displayMessage, 'success')
    } else if (responseCode >= 400 && responseCode < 500) {
        if (displayMessageCustom) {
            displayMessage = displayMessageCustom()
        }
        
        handleAlert('Warning', displayMessage, 'warning', callBackOnOkClick, null, callBackOnOkClick)
    } else if (responseCode >= 500) {
        handleAlert(label, displayMessage, 'error', callBackOnOkClick, null, callBackOnOkClick)
    }
}

export const urlToBase64 = async (imageUrl) => {
    try {
        // Fetch the image from the URL
        const response = await fetch(imageUrl)
        if (!response.ok) {
            throw new Error('Failed to fetch the image')
        }

        // Convert the image to a blob
        const blob = await response.blob()

        // Convert the blob to base64
        return  new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result.split(',')[1])
            reader.onerror = reject
            reader.readAsDataURL(blob)
        })


    } catch (error) {
        console.error('Error:', error)
        return null
    }
}